import { FormSchemaFacade } from './ngrx/form-schema/form-schema.facade';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { offlineProviders } from '@ngx-pwa/offline';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReportListComponent } from './report-list/report-list.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { initDatabase } from './services/rxdb.service';
import { ToastrModule } from 'ngx-toastr';
import { NxModule } from '@nrwl/nx';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './ngrx/index';
import { FormSchemaEffects } from './ngrx/form-schema/form-schema.effects';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { CheckoutListComponent } from './checkout-list/checkout-list.component';
import { SharedModule } from './shared/shared.module';
import { FormsModule } from '@angular/forms';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { ApsAssignedFacade } from './ngrx/aps_assinged/aps_assinged.facade';
import { ApsAssignedEffects } from './ngrx/aps_assinged/aps_assinged.effects';
import { FormDataFacade } from './ngrx/form-data/form-data.facade';
import { FormDataEffects } from './ngrx/form-data/form-data.effects';
import { AlertModule } from 'ngx-bootstrap/alert';
import { UserIdleModule } from 'angular-user-idle';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';


export class MyHammerConfig extends HammerGestureConfig {
    overrides = {
        pinch: { enable: false },
        rotate: { enable: false },
    };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ReportListComponent,
    CheckoutListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    HttpClientModule,
    NxModule.forRoot(),
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([FormSchemaEffects, ApsAssignedEffects, FormDataEffects]),
    ToastrModule.forRoot(),
    SharedModule,
    FormsModule,
    AlertModule.forRoot(),
    UserIdleModule.forRoot({idle: 32400, timeout: 1, ping: 1}),
    // UserIdleModule.forRoot({idle: 20, timeout: 10, ping: 1})
    ModalModule.forRoot(),
  ],
  providers: [
    {
        provide: APP_INITIALIZER,
        useFactory: () => initDatabase,
        multi: true,
        deps: [/* your dependencies */]
    },
    FormSchemaFacade,
    ApsAssignedFacade,
    FormDataFacade,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    offlineProviders({ guardsRedirect: false }),
    BsModalRef
  ],
  bootstrap: [AppComponent],
  exports: [ModalModule]
})
export class AppModule { }
